import { AssortmentItemMinimal } from '@retail/my-assortment/types';
import { useAssortmentTagActions } from '@retail/my-assortment/context';
import EditItemAssortmentTagsDialog from './EditItemAssortmentTagsDialog';

interface Props {
  item: AssortmentItemMinimal;
  assortmentId: number;
  onClose: () => void;
}

export function EditItemAssortmentTagsDialogContainer({ item, assortmentId, onClose }: Props) {
  const { updateAssortmentTags, updateAssortmentTagsIsLoading } = useAssortmentTagActions();

  return (
    <EditItemAssortmentTagsDialog
      open
      item={item}
      assortmentId={assortmentId}
      isSaving={updateAssortmentTagsIsLoading}
      updateAssortmentTags={updateAssortmentTags}
      onClose={onClose}
    />
  );
}
